<template comments>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("nav.projects") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-lg-6 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <!--googleoff: all-->
            <span class="im-lv" v-html="$root.lvContent(0)"></span>
            <!--googleon: all-->

            <p>
              {{ $t("projects.lv_intro") }}
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("projects.lv_feature_1") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_2") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_3") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_4") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_5") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_6") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_7") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_8") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_9") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.lv_feature_10") }}
              </li>
            </ul>

            <!--googleoff: all-->
            <span class="im-lv" v-html="$root.lvContent(1)"></span>
            <!--googleon: all-->
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-6">
        <div class="im-col im-col-2">
          <div class="im-block">
            <h5 class="mb-0">{{ $t("projects.aikidesk_title") }}</h5>

            <p>
              <a href="https://www.aikidesk.com/bg/" target="_blank">www.aikidesk.com</a>
            </p>

            <p>
              {{ $t("projects.aikidesk_intro") }}
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("projects.aikidesk_feature_1") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.aikidesk_feature_2") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.aikidesk_feature_3") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.aikidesk_feature_4") }}
              </li>

              <li class="mb-4">
                {{ $t("projects.aikidesk_feature_5") }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProjectSection",
  };
</script>
